import { useNavigate } from 'react-router-dom'

import { Spinner } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import employees from 'modules/employees/store/collections/employees'
import { castId } from 'modules/time_planning/lib/castId'
import PlanningVersions from 'modules/time_planning/pages/PlanningVersionsPage'
import planningVersions from 'modules/time_planning/store/collections/planningVersions'

const IndexPage = () => {
  const { navigation } = useNavigation()

  const { id, planningVersionId } = useStrictParams<'id' | 'planningVersionId'>()
  const navigate = useNavigate()
  const employee = employees.get(Number(id))!
  const employeeId = employee.attributes.id
  const { loading, value: authorized } = useAsyncCan('planning_versions.read', employee)
  const planningVersion = planningVersions.getPlanningVersion(castId(planningVersionId), employeeId)
  const currentPlanningVersionId = planningVersion?.id

  useUnsafeEffect(() => {
    if (!authorized) {
      navigate(navigation.employees.id.fullPath({ id }))
    }
  }, [id, authorized])

  useUnsafeEffect(() => {
    if (!planningVersionId) {
      navigate(
        navigation.employees.id.planningVersions.planningVersionId.fullPath({
          id,
          planningVersionId: currentPlanningVersionId,
        })
      )
    }
  }, [id, planningVersionId, currentPlanningVersionId])

  if (loading) return <Spinner />

  return <PlanningVersions />
}

export default IndexPage
